import React, { useState, useEffect } from 'react';
import sha256 from 'sha256';
import Navbar from '../navbar';
import queryString from 'query-string';
import { withRouter } from '../../utils/withRouter';

import { Alert } from 'reactstrap';
import { isModernApi } from '../../index';
import { getModernLoginUrl, getLegacyLoginUrl } from '../../config';

interface LoginState {
  origin: any;
  error?: any;
  login?: Record<string, any>;
  wasValidated?: boolean;
  loginFailure?: boolean;
}

function Login(props) {
  const [state, setState] = useState<LoginState>({ origin: null });

  useEffect(
    () => {
      const parsed = queryString.parse(props.location.search);
      const error = parsed.error ? parsed.error : null;
      setState({
        origin: parsed.origin,
        error
      });
    },
    [props.location.search]
  );

  const handleChange = event => {
    setState({
      ...state,
      login: {
        ...state.login,
        [event.target.id]: event.target.value
      }
    });
  };

  const submitLogin = async event => {
    if (!event.target.checkValidity()) {
      setState({
        ...state,
        wasValidated: true
      });
      window.scrollTo(0, 0);
      return;
    }
    const data = new FormData(event.target);
    fetch(isModernApi() ? getModernLoginUrl() : getLegacyLoginUrl(), {
      method: 'POST',
      body: data
    });
  };

  let message = null;
  if (state.loginFailure) {
    message = (
      <div className="alert alert-danger" role="alert">
        Sign In Failed
      </div>
    );
  }
  return (
    <div style={{ height: '100%', minHeight: '100%' }}>
      <Navbar hideLogout={true} />
      <div style={{ maxWidth: '450px', margin: '0 auto', paddingTop: '100px' }}>
        <Alert color="info">Welcome!</Alert>
        <form
          method="POST"
          action={isModernApi() ? getModernLoginUrl() : getLegacyLoginUrl()}
        >
          {message}
          <div className="form-group">
            <div className="col-xs-12">
              <label htmlFor="inputEmail" className="sr-only">
                User Name
              </label>
              <input
                type="text"
                name="username"
                id="username"
                className="form-control form-control-lg"
                placeholder="username"
                required
                autoFocus
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-12">
              <label htmlFor="inputPassword" className="sr-only">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control form-control-lg"
                placeholder="Password"
                required
                onChange={handleChange}
              />
            </div>
          </div>
          <input type="hidden" id="origin" name="origin" value={state.origin} />
          {state.error && (
            <div className="form-group">
              <div className="col-xs-12">
                <div className="alert alert-danger">
                  Incorrect username or password
                </div>
              </div>
            </div>
          )}
          <div className="form-row">
            <div className="form-group col-xs-5">
              <button
                className="btn btn-md btn-primary btn-block"
                style={{ width: '120px' }}
                type="submit"
              >
                Sign In
              </button>
            </div>
            <div className="form-group col-xs-7" style={{ width: '71%' }}>
              <img
                alt="logo"
                width="150px"
                className="float-right"
                src="/images/inst-parchment-logo-color.png"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
//{ console.log(props.location.state.from.pathname)}

export default withRouter(Login);
